import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useProductList } from "../../../Context/ProductListContext";
import { useUser } from "../../../Context/UserContext";
import {formatCurrency, formatCurrencyEur} from "../../../Helper/formatter";
import Button from "../../Button/Button";
// @ts-ignore
import style from "./AddToBasketBar.module.scss?module";
import { useSpring, animated } from "@react-spring/web";

const AddToBasketBar = () => {
  const [show, setShow] = useState(false);

  const {
    flavoursToAdd,
    getUnits,
    getTotal,
    addToBasket,
    isPending,
    isSuccess,
  } = useProductList();
  const springProps = useSpring({
    bottom: show ? 0 : -80,
    config: {
      duration: 300,
    },
  });

  useEffect(() => {
    if (flavoursToAdd.length > 0) {
      setShow(true);
    } else {
      if (isSuccess) {
        const timeout = setTimeout(() => setShow(false), 1500);
        return () => clearTimeout(timeout);
      } else {
        setShow(false);
      }
    }
  }, [flavoursToAdd, isSuccess]);

  return (
    <animated.div
      className={[
        "position-fixed start-0 vw-100 bg-light-gray",
        style.bar,
        // flavoursToAdd.length > 0 ? "d-block" : "d-none",
      ].join(" ")}
      style={springProps}
    >
      <Container className="h-100 px-4 py-2">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            className="d-flex align-items-center justify-content-between justify-content-md-end fw-bold px-md-4 mb-2 mb-md-0"
          >
            {getUnits() > 0 && <span className="me-md-4">UNITS: {getUnits()}</span>}
            {getTotal() > 0 && <span className="ms-md-4">
              TOTAL: {formatCurrencyEur(getTotal())}
            </span>}
          </Col>
          <Col xs={12} md={4}>
            <Button
              className="fst-italic fw-bold"
              onClick={addToBasket}
              loading={isPending}
              success={isSuccess}
            >
              ADD ALL TO BASKET
            </Button>
          </Col>
        </Row>
      </Container>
    </animated.div>
  );
};

export default AddToBasketBar;
